import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustPillars } from '../components/TrustPillars';
import { PainBridge } from '../components/PainBridge';
import { FourPillars } from '../components/FourPillars';
import { AuthorsSection } from '../components/AuthorsSection';
import { ChapterList } from '../components/ChapterList';
import { PackSection } from '../components/PackSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { ClosingQuote } from '../components/ClosingQuote';
import { SalesFooter } from '../components/SalesFooter';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-black" data-id="element-809">
      {/* 1. Hero */}
      <HeroSection data-id="element-810" />

      {/* 2. Trust Pillars */}
      <TrustPillars data-id="element-811" />

      {/* 3. Pain Bridge */}
      <PainBridge data-id="element-812" />

      {/* 4. Four Pillars */}
      <FourPillars data-id="element-813" />

      {/* 5. Authors */}
      <AuthorsSection data-id="element-814" />

      {/* 6. Chapter List */}
      <ChapterList data-id="element-815" />

      {/* 7. The Pack */}
      <PackSection data-id="element-816" />

      {/* 8. Social Proof */}
      <SocialProofSection data-id="element-817" />

      {/* 9. Pricing */}
      <PricingSection data-id="element-818" />

      {/* 10. Closing Quote */}
      <ClosingQuote data-id="element-819" />

      {/* 11. Footer */}
      <SalesFooter data-id="element-820" />

      {/* Recent Purchase Toast */}
      <RecentPurchaseToast data-id="element-821" />
    </main>;
}